import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Eye } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useT } from '../context/I18nContext';
import { toast } from 'sonner';

const ProductCard = ({ product }) => {
  const { add } = useCart();
  const { t } = useT();
  const onSale = product.old_price && product.old_price > product.price;

  return (
    <div className="product-card group rounded-md overflow-hidden flex flex-col">
      <Link to={`/product/${product.slug}`} className="relative block aspect-square overflow-hidden bg-black">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-500" />
        {onSale && (
          <span className="absolute top-3 left-3 bg-[#d4af37] text-black text-xs font-bold px-2 py-1 rounded">SALE</span>
        )}
        <div className="absolute inset-x-0 bottom-0 p-3 flex gap-2 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <button
            onClick={(e) => { e.preventDefault(); add(product); toast.success(`${product.name} added to cart`); }}
            className="flex-1 btn-gold rounded h-10 text-sm font-medium flex items-center justify-center gap-2"
          >
            <ShoppingBag className="h-4 w-4" /> {t('product.add_to_cart')}
          </button>
          <span className="btn-outline-gold rounded h-10 px-3 text-sm flex items-center justify-center gap-1">
            <Eye className="h-4 w-4" /> Quick View
          </span>
        </div>
      </Link>
      <div className="p-5 text-center">
        <h3 className="serif-italic text-xl text-zinc-100 group-hover:text-[#d4af37] transition-colors">
          <Link to={`/product/${product.slug}`}>{product.name}</Link>
        </h3>
        <div className="mt-2 text-zinc-300">
          {onSale ? (
            <>
              <span className="line-through text-zinc-500 mr-2">€{product.old_price.toFixed(2)}</span>
              <span className="text-[#d4af37] font-medium">€{product.price.toFixed(2)}</span>
            </>
          ) : (
            <span className="text-[#d4af37] font-medium">€{product.price.toFixed(2)}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
